import React from 'react';

import { Origin } from '@upstart/harmony/lib/constants';

import Tooltip from 'components/Tooltip';
import { SendButtonProps } from './types';

import './SendToSalespersonButton.scss';
import { sendData } from '../../../util/amplitude';
import { amplitudeEventsDeskingCTR } from '../../../util/amplitudeEvents';

const SendToSalespersonButton = React.memo((props: SendButtonProps) => {
  const { dealId, onSubmit } = props;
  const btnText =
    props.origin === Origin.ONLINE && !props.lastOpenedInStore
      ? 'Update Deal'
      : 'Send to Salesperson';
  return (
    <button
      data-testid="send-button"
      disabled={props.disabled}
      className="send-pencil-button"
      type="button"
      onClick={() => {
        sendData(amplitudeEventsDeskingCTR.DESKING_SENT_TO_SALESPERSON, {
          fniPresentFlow: false,
          dealId,
        });
        onSubmit();
      }}
    >
      {props.tooltip ? (
        <Tooltip text={props.tooltip}>{btnText}</Tooltip>
      ) : (
        btnText
      )}
    </button>
  );
});

export default SendToSalespersonButton;
